import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { TerritoryListScreen } from '../features/territories/TerritoryListScreen'

/** /territories — admin-страница со списком территорий (S40).
 *
 *  Файл назван `territories.index.tsx`, а НЕ `territories.tsx` — иначе
 *  TanStack Router делает `territories` parent для `territories.$id`,
 *  требует у parent-route `<Outlet />`, без которого detail-страница
 *  невидима. Тот же flatten-паттерн применён к orders в #92 — list и
 *  detail оформлены как siblings, без parent-child. */
export const Route = createFileRoute('/territories/')({
  component: TerritoriesIndexRoute,
})

function TerritoriesIndexRoute() {
  return (
    <RequireAuth>
      <TerritoryListScreen />
    </RequireAuth>
  )
}
